var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSessionTimeout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "539 3677 88.189 92.232",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #424a60;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n        stroke-width: 2px;\n      }\n\n      .cls-2 {\n        fill: #afb6bb;\n      }\n\n      .cls-3 {\n        fill: #3083c9;\n      }\n\n      .cls-4 {\n        fill: #2b77aa;\n      }\n\n      .cls-5 {\n        fill: #efce4a;\n      }\n\n      .cls-6 {\n        fill: #424a60;\n      }\n\n      .cls-7 {\n        fill: #a1c8ec;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "stopwatch",
    transform: "translate(537.707 3677)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    className: "cls-1",
    y1: 5.526,
    x2: 5.526,
    transform: "translate(75.113 15.758)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_72",
    "data-name": "Rectangle 72",
    className: "cls-2",
    width: 9.381,
    height: 9.38,
    transform: "translate(76.217 13.547) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_452",
    "data-name": "Path 452",
    className: "cls-3",
    d: "M46.373,6a40.717,40.717,0,0,0-9.125,1.041v9.9H24.742a1.563,1.563,0,0,0,0,3.127H37.248v7.816H16.926a1.563,1.563,0,0,0,0,3.127H37.248v7.816H9.109a1.563,1.563,0,1,0,0,3.127H37.248v7.816H2.856a1.563,1.563,0,0,0,0,3.127H37.248v7.816H12.236a1.563,1.563,0,0,0,0,3.127H37.248v7.816H21.615a1.563,1.563,0,0,0,0,3.127H37.248V86.248A40.643,40.643,0,1,0,46.373,6Z",
    transform: "translate(0 3.38)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_453",
    "data-name": "Path 453",
    className: "cls-4",
    d: "M52.847,23.337a1.569,1.569,0,0,0-2.021-.163L30.586,37.814a5.571,5.571,0,1,0,7.787,7.777L53.009,25.356A1.561,1.561,0,0,0,52.847,23.337Z",
    transform: "translate(15.208 12.887)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_454",
    "data-name": "Path 454",
    className: "cls-5",
    d: "M51.847,21.458a1.569,1.569,0,0,0-2.021-.163L29.586,35.935a5.571,5.571,0,1,0,7.785,7.779L52.008,23.479A1.561,1.561,0,0,0,51.847,21.458Z",
    transform: "translate(14.645 11.829)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_455",
    "data-name": "Path 455",
    className: "cls-6",
    d: "M30.546,9.511c1.033-.078,2.073-.131,3.127-.131s2.093.053,3.127.131V4.69h3.908a2.346,2.346,0,0,0,2.345-2.345h0A2.346,2.346,0,0,0,40.707,0H26.638a2.346,2.346,0,0,0-2.345,2.345h0A2.346,2.346,0,0,0,26.638,4.69h3.908Z",
    transform: "translate(12.955)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_290",
    "data-name": "Group 290",
    transform: "translate(45.064 7.816)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_456",
    "data-name": "Path 456",
    className: "cls-7",
    d: "M30.856,5a1.562,1.562,0,0,0-1.563,1.563v4.69a1.563,1.563,0,0,0,3.127,0V6.563A1.562,1.562,0,0,0,30.856,5Z",
    transform: "translate(-29.293 -5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_457",
    "data-name": "Path 457",
    className: "cls-7",
    d: "M30.856,54a1.562,1.562,0,0,0-1.563,1.563v4.69a1.563,1.563,0,0,0,3.127,0v-4.69A1.562,1.562,0,0,0,30.856,54Z",
    transform: "translate(-29.293 22.599)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_458",
    "data-name": "Path 458",
    className: "cls-7",
    d: "M58.383,31h-4.69a1.563,1.563,0,1,0,0,3.127h4.69a1.563,1.563,0,1,0,0-3.127Z",
    transform: "translate(-16.43 9.645)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_459",
    "data-name": "Path 459",
    className: "cls-7",
    d: "M45.32,8.693a1.562,1.562,0,0,0-2.135.572l-2.345,4.063a1.563,1.563,0,1,0,2.708,1.563l2.345-4.063A1.564,1.564,0,0,0,45.32,8.693Z",
    transform: "translate(-22.907 -3.038)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_460",
    "data-name": "Path 460",
    className: "cls-7",
    d: "M55.454,45.055,51.393,42.71a1.563,1.563,0,1,0-1.563,2.708l4.061,2.345a1.563,1.563,0,0,0,1.563-2.708Z",
    transform: "translate(-18.166 16.121)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_461",
    "data-name": "Path 461",
    className: "cls-7",
    d: "M43.547,51.7a1.563,1.563,0,1,0-2.708,1.563l2.345,4.061a1.563,1.563,0,1,0,2.708-1.563Z",
    transform: "translate(-22.908 20.863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_462",
    "data-name": "Path 462",
    className: "cls-7",
    d: "M50.614,23.472a1.551,1.551,0,0,0,.78-.209l4.061-2.345a1.563,1.563,0,1,0-1.563-2.708l-4.061,2.345a1.563,1.563,0,0,0,.783,2.917Z",
    transform: "translate(-18.166 2.322)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSessionTimeout);
export default __webpack_public_path__ + "static/media/session-timeout.4f485567913eefd5a1af8ab9e176c93f.svg";
export { ForwardRef as ReactComponent };